
import React, { ChangeEvent, useEffect, useState } from 'react'
import onboard from "../../../assets/images/logo.png"
import './missingdocument.scss'
import { Button, Tooltip } from 'antd'
import { triggerNotification, useGetApiRequests } from '../../../common/CommonExport'
import DeleteConfirmationModal from '../../Organization/DeleteConfirmationModal'
import Loader from '../../../components/Loader/Loader'
import { useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { setMissingDocumentList } from '../../../redux/slices/missingDocumentSlice'
import PopupModal from '../../employee/employee-details/employee-profile/modal/PopupModal'
import { useIsMobile } from '../../../hooks/commonHooks'

type Props = {}

const MissingDocuments = (props: Props) => {
  const missingDocumentData = useSelector((state: any) => state?.MissingDocumentList?.missingDocumentList);
  const [deletePopUp, setDeletePopUp] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState('');
  const [loader, setLoader] = useState(true)
  const [documentList, setDocumentList] = useState<any[]>([]);
  const [alreadySubmitted, setAlreadySubmitted] = useState(false)
  const [documentTypeDetails, setDocumentTypeDetails] = useState<any>()
  const [currentPdfDetails, setCurrentPdfDetails] = useState<any>({})
  const [approvedMessage, setapprovedMessage] = useState<any>(null)
  const [modalerrMessage, setModalErrMessage] = useState('')
  const [popModal, setPopModal] = useState(false)
  const [modalResponse, setModalResponse] = useState('')
  const [modalButtonShow, setmodalButtonShow] = useState(true)
  const isMobile = useIsMobile();
  const employeeDocumentDelete = useGetApiRequests('missingDocumentDelete', 'DELETE');
  const employeeDocumentTypes = useGetApiRequests('missingdocument', 'GET');
  const employeeDocumentUpload = useGetApiRequests('missingDocumentUpload', 'POST');
  const dispatch = useDispatch()
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const employeeId = searchParams.get('employeeId');
  const employeeApiKey = searchParams.get('employeeApiKey');
  const organisationId = searchParams.get('organisationId');
  const handlehrImage = (event: ChangeEvent<HTMLInputElement>, item: any) => {
    const file: any = event.target.files?.[0];
    if (!file) return;

    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxSize = 10 * 1024 * 1024;

    if (!allowedTypes.includes(file.type)) {
      setPopModal(true)
      setmodalButtonShow(true)
      setModalErrMessage('Only JPEG, JPG, PNG, and PDF files are allowed.')
      setModalResponse('Warning')
      return;
    }

    if (file.size > maxSize) {
      setPopModal(true)
      setmodalButtonShow(true)
      setModalErrMessage('File size must be less than 10 MB.')
      setModalResponse('Warning')
      return;
    }
    const formData = new FormData();
    formData.append('files', file);
    handleUploadMissingDocument(formData, item?.documentTypeId)
  };

  useEffect(() => {
    missingDocumentList()
  }, []);
  useEffect(() => {
    setDocumentTypeDetails(missingDocumentData);
  }, [missingDocumentData]);

  const missingDocumentList = () => {
    const query = {
      employeeId: employeeId,
      apiKey: employeeApiKey
    }
    employeeDocumentTypes('', query)
      .then((res: any) => {
        setAlreadySubmitted(false)
        setDocumentList(res?.data?.data || []);
        dispatch(setMissingDocumentList(res?.data?.data))
        setapprovedMessage(res?.data?.message)
        setTimeout(() => {
          setLoader(false)
        }, 1500)
      })
      .catch((err: any) => {
        console.error(err);
        setLoader(true)
        setTimeout(() => {
          setLoader(false)
        }, 1500)
        setAlreadySubmitted(true)
      });

  }

  const handleUploadMissingDocument = (formData: any, documentTypeId: any) => {
    const documentDto = {
      documentDto: {
        documentTypeId,
        employeeId: parseInt(employeeId ?? '0'),
        organisationId: parseInt(organisationId ?? '0'),
      },
      apiKey: employeeApiKey,
    };

    const headers = { employeeId: parseInt(employeeId ?? '0') };

    employeeDocumentUpload(formData, documentDto, {}, headers)
      .then((res: any) => {
        triggerNotification('success', '', res?.data?.message, 'topRight');

        if (Array.isArray(res?.data?.data) && res.data.data.length > 0) {
          let updatedMissingDocumentData = [...missingDocumentData];
          const responseData = res?.data?.data[0];
          const folderName = responseData?.document?.folderName;
          const filteredData = updatedMissingDocumentData.map((doc: any) => {
            if (doc?.documentName?.toLowerCase() === folderName?.toLowerCase()) {
              return {
                ...doc,
                response: [...(doc?.response ?? []), responseData], // Ensure response exists
              };
            }
            return doc;
          });
          dispatch(setMissingDocumentList(filteredData));
        }

        setLoader(false)

      })
      .catch((err: any) => {
        console.error(err);
      });
  };



  const handleDeleteDocument = (details: any) => {
    setCurrentPdfDetails(details)
    setDeletePopUp(true)
    setDeleteMessage(`Are you sure you want to delete this ${details?.document?.folderName}?`)
  }
  const handleDeleteSelected = () => {
    const folderName = currentPdfDetails?.document?.folderName;
    const documentDetailId = currentPdfDetails?.documentDetailId;
    const pathParams = {
      id: documentDetailId,
    };

    employeeDocumentDelete('', {}, pathParams)
      .then((res: any) => {
        triggerNotification('success', '', res?.data?.message, 'topRight');
        const deletedFilteredData = missingDocumentData?.map((doc: any) => {
          if (doc?.documentName?.toLowerCase() === folderName?.toLowerCase()) {
            return {
              ...doc,
              response: doc?.response?.filter((res: any) => res?.documentDetailId !== documentDetailId) ?? [],
            };
          }
          return doc;
        });

        dispatch(setMissingDocumentList(deletedFilteredData));

      })
      .catch((err: any) => {
        console.error(err);
      });
  };

  const handleCloseDelete = () => setDeletePopUp(false);
  const handleClosePopUpModal = () => {
    setPopModal(false)
  }
  const handleClosePage = () => {
    setLoader(true);
    setTimeout(() => {
      setLoader(false)
      window.close()
    }, 1000);

  }
  return (
    <section className="approved-screen missing-doc-screen">
      <div className="loader-block">
      </div>
      <div className="header__logo" >
        <img src={onboard} alt="OnboardingLogo" className='ml-[8px]' />
        <span>All-Aboard!</span>
      </div>
      {alreadySubmitted || approvedMessage?.message === 'Seems Like Already Submitted' ? (
        <div className="card">
          <p>
            <span>Seems Like Already Submitted.</span>
          </p>
        </div>
      ) : (
        <div className='flex mx-auto'>
          <div className="doc">
            <div >
              <div>
                <h1 className=' text-xl mb-8 font-medium'>Upload Documents:</h1>
              </div>
              <div className='missing-documents-container'>
                {documentList?.length > 0 && (
                  <>
                    {documentList?.map((item: any, index: any) => (
                      <div className="documents-item document mb-7" key={index}>
                        <div className="document-title mb-4">
                          <h3 className='font-rubik text-base'>{`${index + 1}. ${item?.documentName}`}</h3>

                        </div>
                        {documentTypeDetails?.map((innerItem: any, innerIndex: any) => (
                          <React.Fragment key={innerIndex}>
                            {Array.isArray(innerItem?.response) &&
                              innerItem?.response.map((responseItem: any, responseIndex: number) => (
                                responseItem?.document?.folderName === item?.documentName && (
                                  <div key={`${innerIndex}-${responseIndex}`}>
                                    <div className="document-view flex justify-between items-center md:max-w-xl w-full">
                                      <p className="document-fileName font-rubik text-[12px] lg:text-[16px]">
                                        {responseItem?.name}
                                      </p>
                                      <div className="document-action flex items-center">
                                        {!isMobile ? (
                                          <Tooltip placement="top" title={'Delete'}>
                                            <div className="document-action__icon" onClick={() => handleDeleteDocument(responseItem)}>
                                              <span className="material-symbols-outlined">delete</span>
                                            </div>
                                          </Tooltip>) : (
                                          <div className="document-action__icon" onClick={() => handleDeleteDocument(responseItem)}>
                                            <span className="material-symbols-outlined">delete</span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )
                              ))}
                          </React.Fragment>
                        ))}
                        <div className="document-add">
                          <Button type="text" className='flex items-center text-primary font-rubik' icon={<span className="material-symbols-outlined"> add_circle </span>} size="large">
                            Add Files <input accept="image/jpeg, image/png,image/jpg, application/pdf" type='file' className='absolute opacity-0' onChange={(event) => handlehrImage(event, item)} />
                          </Button>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>

            </div>
            <div className="flex mt-4 mb-3  justify-center w-full ">
              <Button type="primary" shape="round" className='addButton w-[200px]   _deprovision mr-4' onClick={() => handleClosePage()} >
                Close
              </Button>
            </div>
          </div>

        </div>
      )}
      {loader && <Loader />}
      {deletePopUp && <DeleteConfirmationModal open={deletePopUp} handleDeleteSelected={handleDeleteSelected} handleCloseDelete={handleCloseDelete} type='Delete' deleteMessage={deleteMessage} />}
      {popModal && <PopupModal message={modalerrMessage} open={popModal} handleModalClose={handleClosePopUpModal} response={modalResponse} modalButtonShow={modalButtonShow} />}
    </section >

  )
}

export default MissingDocuments